import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import exosLogo2x from 'assets/logo@2x.png';

import exosLogo from 'assets/logo.png';
import React, { ReactElement, ReactNode } from 'react';

const Main = styled('main')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  marginTop: theme.baseUnit,
  marginBottom: theme.baseUnit * 3,
  '& img': {
    maxWidth: '100%',
  },
  '@media (max-width: 800px)': {
    justifyContent: 'center',
  },
}));

interface Props {
  client?: {
    name?: string;
    logo_url?: string;
  };
  children: ReactNode | ReactNode[];
}

const Branding = ({ client, children }: Props): ReactElement => (
  <Main>
    <Box display="flex" flexDirection="column">
      <LogoContainer>
        {client ? (
          <img src={client.logo_url} alt={client.name} />
        ) : (
          <img
            src={exosLogo}
            srcSet={`${exosLogo} 1x,${exosLogo2x} 2x`}
            alt="Exos"
          />
        )}
      </LogoContainer>
      {children}
    </Box>
  </Main>
);

export default Branding;
